import React, { useState, useRef, useEffect } from "react";
import "./CurrencySelect.css";

const CurrencySelect = ({ onCurrencyChange, selectedCurrency, currencies }) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    const handleSelectCurrency = (currency) => {
        if (onCurrencyChange) onCurrencyChange(currency);
        setShowDropdown(false);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setShowDropdown(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="currency-select" ref={dropdownRef}>
            <label>Выберите валюту</label>
            <div
                className="input-wrapper"
                onClick={() => setShowDropdown(!showDropdown)}
            >
                <div className="currency-input">

                    <div className="currency-info">
                        <div className="currency-symbol">{selectedCurrency}</div>

                    </div>
                </div>
                <span className="dropdown-arrow">&#9662;</span>
            </div>

            {showDropdown && (
                <ul className="dropdown-list">
                    {currencies.map((currency, index) => (
                        <li
                            key={index}
                            onClick={() => handleSelectCurrency(currency)}
                            className={
                                selectedCurrency === currency ? "selected" : ""
                            }
                        >
                            <div className="currency-option">
                                <div className="currency-info">
                                    <div className="currency-symbol">{currency}</div>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default CurrencySelect;
